const state = {
  processing: false,
  bulkProcessing: false,
  lates: [],
};

export default state;
